<template>
<div class="chapter">
<div class="inner_page">
<h2 class="calibre4 sigil_not_in_toc" id="calibre_pb_0" title="Dedication, In memory of Susan">Dedication</h2>
<h3 class="sigilnotintoc sigil_not_in_toc" style="text-align: center;">In memory of Susan</h3>
<div class="calibre5" id="calibre_pb_1"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// index_split_001.vue?6ba3afc8